import React from 'react';

function LogoRainbow(props) {
  return (
    <svg viewBox="0 0 265.5 447.82" {...props}>
      <defs>
        <linearGradient
          id="icon-logo-rainbow-gradient"
          x1="-6.5327"
          y1="324.1642"
          x2="241.775"
          y2="75.8565"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ff00c7" />
          <stop offset="0.5237" stopColor="#434cff" />
          <stop offset="1" stopColor="#0cd" />
        </linearGradient>
      </defs>
      <g>
        <g fill="url(#icon-logo-rainbow-gradient)">
          <path d="M.1,367.52h0a8.48,8.48,0,0,0,4.2,7.4l124.4,71.8a8,8,0,0,0,4.2,1.1,8.77,8.77,0,0,0,4.2-1.1,8.48,8.48,0,0,0,4.2-7.4V310.42l111.6,64.4a8,8,0,0,0,4.2,1.1,8.77,8.77,0,0,0,4.2-1.1,8.48,8.48,0,0,0,4.2-7.4V80.32a8.7,8.7,0,0,0-4.2-7.39L137.2,1.12a8.59,8.59,0,0,0-8.5,0,8.5,8.5,0,0,0-4.2,7.41V137.42L12.8,72.93A8.55,8.55,0,0,0,0,80.32Zm25.5-143.6,98.9-57.1V281Zm214.7,0L141.4,281V166.82ZM248.8,95v114.2l-98.9-57.1ZM17.1,352.83V238.62L116,295.73ZM17.1,95l98.9,57.1L17.1,209.23Zm124.4-71.8,98.9,57.1-98.9,57.1ZM248.8,352.83l-98.9-57.1,98.9-57.11ZM124.5,424.62l-98.9-57.1,98.9-57.1Z" />
        </g>
      </g>
    </svg>
  );
}

export default LogoRainbow;
